'use client';

import { Button } from '@mui/material';
import { FC } from 'react';

import { Loader } from '@abg/kit-base';
import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { useLoginAmazonJourney } from '../../hooks';
import { useAnalyticsLoginFunnel } from '../../shared/analytics/hooks';
import { userStoreSelector } from '../../store';

import { AmazonLoginButtonProps } from './types';

export const AmazonLoginButton: FC<AmazonLoginButtonProps> = ({
  buttonCaption,
  ctaStyle,
}) => {
  const { brand } = usePageContext();

  const recordAnalyticsLoginFunnel = useAnalyticsLoginFunnel();
  const { isLoading, startLoginJourney } = useLoginAmazonJourney({});
  const userSession = userStoreSelector.use.userSession();
  const { amazonLogin } = userSession ?? {};

  const handleClick = async () => {
    recordAnalyticsLoginFunnel({
      method: 'Amazon',
      login_state: 'login',
      step_number: 1,
      step_description: 'Overview',
    });
    await startLoginJourney();
  };

  if (amazonLogin) return null;

  return (
    <>
      <Loader isActive={isLoading} brand={brand} />
      <Button
        disabled={isLoading}
        onClick={() => void handleClick()}
        component="button"
        data-testid="content-module-amazon-login-button"
        classes={{ root: ctaStyle ?? '' }}
      >
        {buttonCaption}
      </Button>
    </>
  );
};
